import * as React from "react";
import { useNavigate } from "react-router-dom";
import PlantGridColumns from "./PlantGridColumns";
import PlantOverviewItem from "./PlantOverviewItem";
import SingleSelectKendoGrid from "../../Grid/Selectable/SingleSelectKendoGrid";
import { combinedUrls } from "../../URL/functions";
import { plantUrls } from "../../URL/ApplicationUrls";
import PageHeader from "../../Layout/Header/PageHeader";
import { defaultAddButton } from "../../Grid/Toolbar/DefaultAddButton";
import { defaultEditButton } from "../../Grid/Toolbar/DefaultEditButton";
import { plantTypeAsString } from "../PlantType";
import { createExportButton } from "../../Grid/ExcelExport/CreateExportButton";
import { AuthorizationPolicies } from "../../Auth/AuthorizationPolicy";
import { useRoles } from "../../Auth/RoleProvider";
import { useIsUserInRoles } from "../../Auth/useIsUserInRoles";

export default function PlantOverview() {
  const navigate = useNavigate();

  const addPlant = () => navigate(plantUrls.addPlant.uiPath);

  const editPlant = (plant: PlantOverviewItem | undefined) =>
    plant && navigate(plantUrls.plantWithId(plant.PlantID).uiPath);

  const url = combinedUrls(plantUrls.base.apiUrl, "KendoGrid");

  const isUserInAdminNetworkRole = useIsUserInRoles(AuthorizationPolicies.RequireAdminNetworkRoles);

  return (
    <>
      <PageHeader headerText="Plant" />
      <SingleSelectKendoGrid
        localStorageKey="PlantOverviewGrid_DataState"
        fetchUrl={url}
        columns={PlantGridColumns({ isReadOnly: !isUserInAdminNetworkRole })}
        idSelector={(plant: PlantOverviewItem) => plant.PlantID}
        toolbarItems={[
          defaultAddButton({
            onClick: addPlant,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
          defaultEditButton({
            onClick: editPlant,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
        ]}
        onRowDoubleClick={editPlant}
        customToolbarItems={[
          createExportButton({
            url,
            filename: "Plants",
            mapping: (plant: PlantOverviewItem) => ({
              ...plant,
              PlantType: plantTypeAsString.get(plant.PlantType),
            }),
          }),
        ]}
      />
    </>
  );
}
